import { Injectable, Input } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class LoggerService {

    constructor() {
        // TODO
    }

    public log(component: string, msg?: string, i18nRef?: string, data?: string[]) {
        if (!environment.silent) {
            if (i18nRef) {
                let params: {} = {};
                if (data) {
                    params = (data[0]) ? { 0: data[0] } : params;
                    params = (data[1]) ? { 0: data[0], 1: data[1] } : params;
                    params = (data[2]) ? { 0: data[0], 1: data[1], 2: data[2] } : params;
                }
                // this.translate.getTranslate().get(i18nRef, params).subscribe((res: string) => {
                //     console.log(component + ': ' + res);
                // });
            } else {
                console.log(component + ': ' + msg);
            }
        }
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/logger.service.ts